<template>
  <section>
    <section-header
      class="d-sm-none"
      @toggle="showSection = !showSection"
      :showSection="showSection"
    >Summary</section-header>
    <toggle-header
      class="d-none d-sm-block"
      :id="'summary-' + this._uid"
      v-model="showSection"
    >Summary</toggle-header>
    <div v-if="showSection">
      <fifth-edition v-if="['5th Edition', '5e24'].includes(item.ruleset)" :item="item"></fifth-edition>
      <solarian-conflict v-if="item.ruleset === 'Solarian Conflict'" :item="item"></solarian-conflict>
      <pfrpg v-if="item.ruleset === 'PFRPG'" :item="item"></pfrpg>
      <pfrpg2 v-if="['PF Playtest', 'PFRPG2', 'Embers RPG'].includes(item.ruleset)" :item="item"></pfrpg2>
      <savage-worlds v-if="['Savage Embers', 'Savage Worlds'].includes(item.ruleset)" :item="item"></savage-worlds>
    </div>
  </section>
</template>
<script>
import { mapState } from "vuex";
import FifthEdition from "./_5thEdition.vue";
import Pfrpg from "./_Pfrpg.vue";
import Pfrpg2 from "./_Pfrpg2.vue";
import SolarianConflict from "./_SolarianConflict.vue";
import SavageWorlds from "./_SavageWorlds.vue";
import SectionHeader from "../shared/_SectionHeader.vue";
import ToggleHeader from "../shared/_ToggleHeader.vue";

export default {
  name: "character-sheet-core-index",
  components: {
    FifthEdition,
    Pfrpg,
    Pfrpg2,
    SolarianConflict,
    SavageWorlds,
    SectionHeader,
    ToggleHeader,
  },
  data() {
    return {
      showSection: true,
    };
  },
  mounted() {
    if (this.item.core && this.item.core.experience && this.item.core.class) {
      this.showSection = false;
    }
  },
  computed: mapState({
    item: (state) => state.characters.current,
  }),
};
</script>

<style lang="scss" scoped>
section {
  margin-bottom: 1em;
  @media screen and (max-width: 640px) {
    margin-bottom: 0;
  }
}
</style>
